// export default function multipartDataHelper(formData, sendData, stringify=false) {
//   for (const key in sendData) {
//     if (
//       stringify &&
//       (typeof sendData[key] === "object" || Array.isArray(sendData[key]))
//     ) {
//       formData.append(key, JSON.stringify(sendData[key]));
//     } else {
//       formData.append(key, sendData[key]);
//     }
//   }
//   return formData;
// }

export default function multipartDataHelper(
  formData,
  sendData,
  isLooping = []
) {
  // console.log(isLooping, "isLooping");

  for (const key in sendData) {
    // Check if the key is in the `isLooping` array
    if (isLooping?.length && isLooping.includes(key)) {
      // console.log(sendData[key], "sendData Key ");
      sendData[key].forEach((element, index) => formData.append(key, element));
    } else {
      // Handle non-looping keys
      if (
        typeof sendData[key] === "object" &&
        !(sendData[key] instanceof File) && !Array.isArray(sendData[key])
      ) {
        formData.append(key, JSON.stringify(sendData[key]));
      } else {
        formData.append(key, sendData[key]);
      }
    }
  }

  return formData;
}

// Consoling FormData
export const printFormData = (formData) => {
  // return
  console.log(Object.fromEntries([...formData.entries()]), "FOrmData");
};
